module.exports = __webpack_public_path__ + "static/media/layout7-vid.53b46b5e.svg";